module.exports = __webpack_public_path__ + "static/img/news-img4.1e5044d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news-img4.png
// module id = vwxR
// module chunks = 3